import { Link } from 'react-router';
import { roleLabel, thinkingLabel } from '../../lib/plain.js';
import { relativeTime } from '../../lib/format.js';
import { useDrawer } from '../../state/drawer.js';
import { useHealth } from '../../state/health.js';
import { Badge } from '../ui.js';

/** The details drawer: facts about the current conversation and the deployment health. */
export function DetailsDrawer({ projectName }: { projectName: string | undefined }) {
  const { info, open } = useDrawer();
  const { health, aiState } = useHealth();
  const tone = aiState === 'available' ? 'ok' : aiState === 'loading' ? 'warn' : 'bad';
  const label = aiState === 'available' ? 'Available' : aiState === 'loading' ? 'Loading' : 'Unavailable';
  return (
    <>
      <aside className="drawer" aria-hidden={!open}>
        <h3>Details</h3>
        <dl>
          <dt>AI</dt>
          <dd>
            <Badge tone={tone}>{label}</Badge>
            {health?.inference.latencyMs != null ? <span className="muted tiny"> {health.inference.latencyMs} ms</span> : null}
          </dd>
          {projectName ? (
            <>
              <dt>Project</dt>
              <dd>{projectName}</dd>
            </>
          ) : null}
          {info.contextVersion != null ? (
            <>
              <dt>Project notes</dt>
              <dd>
                Version {info.contextVersion}
                {info.projectId ? (
                  <>
                    {' '}
                    <Link to={`/p/${info.projectId}/knows`} className="tiny">
                      view
                    </Link>
                  </>
                ) : null}
              </dd>
            </>
          ) : null}
          {info.role ? (
            <>
              <dt>Jabberr as</dt>
              <dd>{roleLabel(info.role)}</dd>
            </>
          ) : null}
          {info.reasoningEffort ? (
            <>
              <dt>Thinking</dt>
              <dd>{thinkingLabel(info.reasoningEffort)}</dd>
            </>
          ) : null}
          {info.conversationKind ? (
            <>
              <dt>Type</dt>
              <dd>{info.conversationKind === 'review' ? 'Transcript review' : info.conversationKind === 'meeting' ? 'Meeting' : 'Conversation'}</dd>
            </>
          ) : null}
          <dt>Model</dt>
          <dd className="mono small">{health?.inference.model ?? '...'}</dd>
          <dt>Deployment</dt>
          <dd className="mono tiny break">{health?.inference.deploymentId ?? '...'}</dd>
          {health ? (
            <>
              <dt>Checked</dt>
              <dd className="tiny muted">{relativeTime(health.inference.checkedAt)}</dd>
              <dt>API</dt>
              <dd className="tiny muted">
                {health.version} · db {health.db}
              </dd>
            </>
          ) : null}
        </dl>
      </aside>
    </>
  );
}
